/**
 * @generated SignedSource<<efd1ff671cafa9f06159c6e3f78c2165>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type LoginActivateQuery$variables = {
  key: string;
};
export type LoginActivateQuery$data = {
  readonly loginActivation: {
    readonly hasExistingLogin: boolean;
  } | null | undefined;
};
export type LoginActivateQuery = {
  response: LoginActivateQuery$data;
  variables: LoginActivateQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "key"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "key",
    "variableName": "key"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hasExistingLogin",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "LoginActivateQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "LoginActivation",
        "kind": "LinkedField",
        "name": "loginActivation",
        "plural": false,
        "selections": [
          (v2/*:: as any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "LoginActivateQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "LoginActivation",
        "kind": "LinkedField",
        "name": "loginActivation",
        "plural": false,
        "selections": [
          (v2/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "6ec20cc1584ce31bfb8bf19298693344",
    "id": null,
    "metadata": {},
    "name": "LoginActivateQuery",
    "operationKind": "query",
    "text": "query LoginActivateQuery(\n  $key: String!\n) {\n  loginActivation(key: $key) {\n    hasExistingLogin\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "b3cd6de0231caba0095cf24fadf5f564";

export default node;
